export default __webpack_public_path__ + "static/media/potato-20.e7139e94.png";